<template>
  <div>
    <b-form-group label="Grower" :label-cols="3" class="mb-3">
      <b-form-input
        v-model="form.name"
        name="grower_name"
        type="text"
        class="form-control"
        placeholder="Grower Name"
        autocomplete="grower_name"
        :state="vuelidate.name.$dirty ? !vuelidate.name.$invalid : null"
      />
    </b-form-group>
  </div>
</template>

<script>
export default {
  name: 'CustomerGrowerFormGroup',
  props: {
    customer_grower: {
      type: Object,
      default: () => {}
    },
    vuelidate: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      form: {
        name: null
      }
    }
  },
  watch: {
    form: {
      handler () {
        this.$emit('onChange', this.form)
      },
      deep: true
    },
    'vuelidate.name.$model': {
      handler () {
        this.form.name = this.vuelidate.name.$model
      },
      immediate: true
    }
  },
  created () {
    this.fillForm()
  },
  methods: {
    fillForm () {
      if (this.customer_grower) {
        for (const i in this.form) {
          if (this.customer_grower[i]) {
            this.form[i] = this.customer_grower[i]
          }
        }
      }
    }
  }
}
</script>
